import { Box } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ISessionState } from "../../../models/session/sessionState";
import { Dialog } from "../../framework/Dialog/Dialog";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";
import { IAppReportPageFilterState } from "../AppReportPage/AppReportPageUtils";
import { AppReportList } from "../AppReportList/AppReportList";
import { useState } from "react";

interface IAppReportTrashBinDialogProp {
    sessionState: ISessionState;
    companyId: string;
    units: IIdTitleNode[];
    onLoadPageData: () => void;
    onClose: () => void;
}

interface IAppReportTrashBinDialogState extends IAppReportPageFilterState {
    sortColumn: string;
    sortOrderIsAsc: boolean;
}

export const AppReportTrashBinDialog = (props: IAppReportTrashBinDialogProp) => {
    const [state, setState] = useState<IAppReportTrashBinDialogState>({
        selectedUnitIds: [],
        selectedStateIds: [],
        sortColumn: "modifyDate",
        sortOrderIsAsc: false,
    });
    
    const handleFilterSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        setState((old) => ({
            ...old,
            sortColumn,
            sortOrderIsAsc,
        }));
    };

    return (
        <Dialog
            id="appReportTrashBinDialog"
            maxWidth="xl"
            maxHeight="100%"
            title={Translations.TrashBin}
            body={
                <>
                    <AppReportList
                        filterName={null}
                        sessionState={props.sessionState}
                        dataId={"0"}
                        addRecord={false}
                        canCreateAppReports={false}
                        listFilterIsSet={false}
                        units={props.units}
                        selectedUnitIds={state.selectedUnitIds}
                        selectedStateIds={state.selectedStateIds}
                        companyId={props.companyId}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        settingsActions={[]}
                        thrashBin={true}
                        showDocumentPreview={false}
                        onOpenFiltersDialog={null}
                        onSetSortData={handleFilterSortData}
                        onLoadPageData={props.onLoadPageData}
                        onOpenTrashBinDialog={null}
                        onChangeShowDocumentPreview={null}
                        onToggleSettingsDialog={null}
                        reportTabs={null}
                    />
                </>
            }
            actions={
                <Box display="flex" justifyContent="end" width="100%">
                    <AppButton variant="outlined" onClick={props.onClose}>{Translations.Close}</AppButton>
                </Box>
            }
            onClose={props.onClose}/>
    );
};